<template>
  <div class="">
    <div class="card-header">
      <h4 class="card-title">Enrollments</h4>
    </div>
    <div class="card-content" style="background: #f5f6f7; padding: 0 15px 0 0; border-radius:5px;">

      <time-line type="simple">
       
        <time-line-item badgeIcon="ti-shopping-cart-full" v-for="(order, index) in orders" :key="index" class="timeline-inverted" badge-type="info" background="#f1f1f1">
          <span slot="header" class="label label-danger"></span>
          <div slot="body">
          
            <order :order="order" @on-edit="handleOrderEdit" @on-delete="handleOrderDelete">

            </order>
          </div>
          <h6 slot="footer">
            <span v-if="order.dateCreated != null">{{order.dateCreated | moment('DD/MM/YYYY')}}</span> 
          </h6>
        </time-line-item>
      </time-line>
    </div>

  </div>
</template>
<script>
import TimeLine from "./TimeLine.vue";
import TimeLineItem from "./TimeLineItem.vue";
import Order from "./Order.vue";

export default {
  props: ["orders"],
  components: {
    Order,
    TimeLine,
    TimeLineItem
  },
  methods: {
    handleOrderEdit(index) {
      console.log(index);
      alert(`You want to edit task: ${JSON.stringify(this.orders[index])}`);
    },
    handleOrderDelete(index) {
      alert(`You want to delete task: ${JSON.stringify(this.orders[index])}`);
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/OrderList.vue